import React, { useCallback, useRef } from 'react'
import { CSSTransition } from 'react-transition-group';

import { Container } from './styles'

interface IModalBackdropProps {
    isOpen: boolean;
    onClose: () => void;
}

const ModalBackdrop: React.FC<IModalBackdropProps> = ({ isOpen, onClose, children }) => {

    const nodeRef = useRef(null)

    const onCloseBackdropHandler = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.id === 'backdrop') {
            onClose()
        }
    }, [onClose])

    return (
        <CSSTransition nodeRef={nodeRef} in={isOpen} timeout={200} classNames="opacity__effect" unmountOnExit>
            <Container ref={nodeRef} id='backdrop' onClick={(event: React.ChangeEvent<HTMLInputElement> | any) => onCloseBackdropHandler(event)}>
                {children}
            </Container>
        </CSSTransition>

    )
}

export default ModalBackdrop